import { format, subDays } from "date-fns";
import { createContext, useState } from "react";

export const DateRangeContext = createContext(null);

const initialDate = [
  {
    startDate: subDays(new Date(), 5),
    endDate: subDays(new Date(), 2),
    key: "selection"
  }
];

export const DateRangeContextProvider = ({ children }) => {
  const [date, setDate] = useState(initialDate);
  const [finalDate, setFinalDate] = useState({
    startDate: format(initialDate[0].startDate, "yyyy-MM-dd"),
    endDate: format(initialDate[0].endDate, "yyyy-MM-dd")
  });

  function handleSelect(item) {
    setDate([item.selection]);
  }

  function handleFinalDate(date) {
    const startDate = format(date[0].startDate, "yyyy-MM-dd");
    const endDate = format(date[0].endDate, "yyyy-MM-dd");

    setFinalDate({
      startDate,
      endDate
    });
  }

  return (
    <DateRangeContext.Provider
      value={{
        date,
        finalDate,
        handleSelect,
        handleFinalDate
      }}>
      {children}
    </DateRangeContext.Provider>
  );
};
